import React from 'react';

const UserTag = ({ status }) => {
    const tagClass = status === 'active' ? 'bg-success' : 'bg-danger';
    const tagText = status === 'active' ? 'Active' : 'Inactive';

    return (
        <span className={`badge ${tagClass}`} style={{ marginTop: '5px' }}>
            {tagText}
        </span>
    );
};

export default UserTag;
